module.exports = __webpack_public_path__ + "img/rocket-white.b63e5d40.png";